
import { Typography } from '@mui/material';

import { ErrorMessage } from '@src/components/ErrorMessage';
import { RecaptchaV2 } from '@src/components/RecaptchaV2';
import { SubmissionErrorMessage } from '@src/components/SubmissionErrorMessage';
import { SubmissionStatus } from '@src/components/SubmissionStatus';

export function ContactForm({
  submissionStatus,
  setSubmissionStatus,
  recaptchaError,
  setRecaptchaError,
  csrfHookInfo,
  formData,
  handleInputChange,
  mutation,
  errors,
  clearError,
  setRecaptchaResetFunc,
  handleSubmit,
}) {
  return (
    <div className="md:w-2/3 bg-white rounded-xl shadow-2xl p-6 sm:p-10 border border-gray-100">
      <Typography
        variant="h4"
        component="h1"
        className="text-3xl! font-extrabold! text-gray-900! mb-6!"
      >
        Send us a Message
      </Typography>

      <SubmissionErrorMessage
        csrfHookInfo={csrfHookInfo}
        submissionError={mutation.error}
        submissionStatus={mutation.status}
      />

      <form className="space-y-6" onSubmit={handleSubmit}>
        {/* Loading/Status Indicator */}

        <SubmissionStatus csrfHookInfo={csrfHookInfo} submissionStatus={submissionStatus} setSubmissionStatus={setSubmissionStatus} />

        {/* Form Inputs */}
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">Full Name</label>

          <input
            id="name"
            type="text"
            name="name"
            value={formData.name}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"

            onChange={(e) => {
              handleInputChange('name', e.target.value);
              clearError('name');
            }}
          />

          <ErrorMessage error={errors.name} />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>

          <input
            id="email"
            type="text"
            name="email"
            value={formData.email}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"

            onChange={(e) => {
              handleInputChange('email', e.target.value);
              clearError('email');
            }}
          />

          <ErrorMessage error={errors.email} />
        </div>

        <div>
          <label htmlFor="subject" className="block text-sm font-medium text-gray-700">Subject</label>

          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"

            onChange={(e) => {
              handleInputChange('subject', e.target.value);
              clearError('subject');
            }}
          />

          <ErrorMessage error={errors.subject} />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>

          <textarea
            rows="4"
            id="message"
            name="message"
            value={formData.message}
            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"

            onChange={(e) => {
              handleInputChange('message', e.target.value);
              clearError('message');
            }}
          />

          <ErrorMessage error={errors.message} />
        </div>

        <RecaptchaV2
          errors={errors}
          formData={formData}
          recaptchaError={recaptchaError}
          setRecaptchaError={setRecaptchaError}
          onInputChange={handleInputChange}
          onResetReady={setRecaptchaResetFunc}
        />


        <button

          type="submit"
          disabled={submissionStatus === 'submitting' || csrfHookInfo.isLoading || !csrfHookInfo.isCsrfReady || recaptchaError}
          className={`w-full py-3 px-4 border border-transparent rounded-lg shadow-md text-white font-semibold transition-all duration-300
                ${submissionStatus === 'submitting' || csrfHookInfo.isLoading || !csrfHookInfo.isCsrfReady || recaptchaError
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-blue-600 hover:bg-blue-700 hover:shadow-lg active:scale-[0.98]'
    }`}
        >
          {csrfHookInfo.isLoading ? 'Loading Security...' : submissionStatus === 'submitting' ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
}
